
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
	import {
		profitStatisticOrderList
	} from '@/api/statistic'
	import {
		nextDay
	} from "@/utils"
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate
    }
  })

  export default class ProductList extends Vue {
    private query:any = {}
    private loading = false;
		private defaultAvatar = 'https://cdn2024.shiwuzone.com/routuan/image/20230110-0f54988a-9589-45bc-ad27-844c60e80f36.png'
		private list: any = [];
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;
		private keywords = '';
		private type = null;
		private selectList: any = [{
			value: null,
			label: '全部'
		}, {
			value: 1,
			label: '零售利润'
		}, {
			value: 2,
			label: '分销利润'
		}, {
			value: 3,
			label: '服务费'
		}];
    private State = null
    private Statelist = [{
			value: null,
			label: '全部'
		}, {
			value: 0,
			label: '待结算'
		}, {
			value: 1,
			label: '已生效'
		}, {
			value: 2,
			label: '已失效'
		}]

    private mounted () {
      this.query = this.$route.query
      this.query.Name = decodeURIComponent(this.query.Name)
      this.getList()
    }
		
		private changePage(e) {
			this.pageNo = +e;
			this.getList();
		}
		
		private doSearch() {
			this.pageNo = 1;
			this.getList();
		}
		
		private clearSearch() {
			this.pageNo = 1;
			this.keywords = '';
			this.type = null;
      this.State = null
			this.getList();
		}
		
		private async getList() {
			let params: any = {
				Skip: (this.pageNo - 1) * this.pageSize,
				Take: this.pageSize,
				MemberId: this.$route.query.Id,
				RoleGrade:this.$route.query.RoleGrade,
				SuperId:this.$route.query.SuperId,
				Keywords: this.keywords,
				StartTime:'',
				EndTime:'',
				Type: this.type,
        State:this.State,
			}
			if (this.query.filterTime) {
				var dt = this.query.filterTime.split('/');
				params.StartTime = dt[0];
				params.EndTime = nextDay(dt[1],1)
			}
			this.loading = true;
			try {
				const res: any = await profitStatisticOrderList(params);
				this.list = res.Result.Results
				this.total = res.Result.Total;
			} catch (e) {
				console.log(e)
			} finally{
				this.loading = false;
			}
		}
		
		/**
		 * 导出
		 */
		private exportExcel(){
			var url = location.origin + '/pc/profitStatistic/orderExport?';
			url += 'Keywords=' + this.keywords;
			url += '&Type=' + (this.type===null ? '' : this.type);
			url += '&State=' + (this.State===null ? '' : this.State);
			url += '&MemberId=' + this.$route.query.Id;
			url += '&RoleGrade=' + this.$route.query.RoleGrade;
			url += '&SuperId=' + this.$route.query.SuperId;

			if (this.query.filterTime) {
				var dt = this.query.filterTime.split('/');
				url += '&StartTime=' + dt[0];
				url += '&EndTime=' + nextDay(dt[1],1);
			}
			
			console.log(url)
			window.open(url)
			
		}
  }
